import { DOCUMENT, inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, map, throwError } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from './auth.service';

export enum USER_ROLE {
  CONSUMER = 'consumer',
  ADVISOR = 'advisor',
  SUPPLIER = 'supplier',
  SPONSOR = 'sponsor',
}
@Injectable({
  providedIn: 'root'
})
export class FilesService {
  private apiUrl = environment.apiUrl.replace('/api/v1/public', '/api/v1/client');
  private httpClient = inject(HttpClient);

  private authService = inject(AuthService);
  
  // save file
  async saveFileApi(file: File, folder: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    return firstValueFrom(
      this.httpClient.post(`${this.apiUrl}/files`, formData, { headers: {
        'Authorization': this.authService.getAuthHeaders().Authorization,
      } })
        .pipe(
          map((response: any) => {
            return response.data;
          })
        )
    );
  }
}
